import React from 'react';

import { useResto } from '../../contexts/RestoContext';

const TopDemo = () => {

  const { restoData } = useResto();

  if (!restoData || !restoData.isDemo) {
    return;
  }

  return (
    <div id="demo-block" className="demo-message">
        ATTENTION ! Ce site est un site de démonstration. Les données, photos et documents sont seulement à titre illustratif.
    </div>
)};

export default TopDemo;
